import { render, staticRenderFns } from "./OutrosTemas.vue?vue&type=template&id=37babf0e&scoped=true"
import script from "./OutrosTemas.vue?vue&type=script&lang=js"
export * from "./OutrosTemas.vue?vue&type=script&lang=js"
import style0 from "./OutrosTemas.vue?vue&type=style&index=0&id=37babf0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37babf0e",
  null
  
)

export default component.exports